import Model from "../Model";

class KpiGraphsComercialClientUser extends Model{

    buildUrl ({ param }) {
        return ['kpizoneclientview/getbyuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new KpiGraphsComercialClientUser;